Vue.asyncComponent('ak-data-chip', {
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
    },
    computed: {
        isLink() {
            return this.$listeners.hasOwnProperty('click');
        },
    },
    methods: {
        /**
         * Trigger click
         */
        triggerClick() {
            // only trigger if this element is a link
            if (! this.isLink) {
                return;
            }

            this.$emit('click');
        }
    }
}, 'layout/ak-data-chip.html');